var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"user-quiz"}},[_c('small-header'),_c('div',{staticClass:"container"},[_vm._m(0),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('list-dropdown',{attrs:{"userLists":_vm.userLists}})],1)])]),_c('custom-footer')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_vm._v("\n        User quiz tracking\n      ")])])
}]

export { render, staticRenderFns }